import './FDOTFooter.css';
import { useContext } from 'react';
import { FileHashContext } from '../file_hash_context';

function FDOTFooter(props) {
  const { fileHash } = useContext(FileHashContext);
  return (
    <footer>
      <div>© FDOT, {props.ccyear}</div>
      <div>
        <a href="https://www.myflorida.com/">MyFlorida.com</a>
      </div>
      <div>
        <a href="https://www.fdot.gov/agencyresources/webpoliciesandnotices.shtm">
          Web Policies and Notices
        </a>
      </div>
      <div>
        Version. {process.env.REACT_APP_VERSION} ({fileHash})
      </div>
    </footer>
  );
}
export default FDOTFooter;
